import{QueueAction as e}from"./QueueAction.js";import{QueueScheduler as r}from"./QueueScheduler.js";var o=new r(e),u=o;export{u as queue,o as queueScheduler};
